/**
 * How much of a free report is visible, in one place.
 *
 * These numbers are used by two things that must agree: the report page, which
 * decides what to render, and the post-audit nurture sequence, which tells the
 * reader how many findings are still locked. They were duplicated, and the
 * moment the gate became proportional the sequence kept subtracting the old flat
 * 8, so a report with exactly 8 findings enrolled with hidden_count 0 and its
 * emails would have argued that nothing was left to unlock.
 */

/** Findings shown before an email is given: enough to prove the report is real. */
export const PREVIEW_FINDINGS_COUNT = 1;

/**
 * Findings visible once an email has been given. Never the whole set above the
 * trivial sizes, so the paid tier always has something left.
 */
export function unlockedCount(total: number): number {
  if (total <= 3) return total; // too small to withhold anything meaningfully
  return Math.max(3, Math.ceil(total / 2));
}

/** Findings still behind the paywall after the email unlock. */
export function hiddenAfterUnlock(total: number): number {
  return Math.max(0, total - unlockedCount(total));
}
